import script from "./HeaderContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderContent.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderContent.vue?vue&type=style&index=0&id=5727c1e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5727c1e8"]])

export default __exports__